import {
	Component,
	OnInit,
	Input,
	ViewChild,
	ViewContainerRef,
	ElementRef,
	Output,
	EventEmitter,
	SimpleChange,
} from "@angular/core";
import { DocBar } from "../../core/vo/docBar";

@Component({
	selector: "app-progress-spinner",
	templateUrl: "./progress-spinner.component.html",
	styleUrls: ["./progress-spinner.component.scss"],
})
export class ProgressSpinnerDirective implements OnInit {
	@Input() progressVal: number;
	@Input() showArrow: boolean = false;
	@ViewChild("circle", { static: true }) circleEl: ElementRef;
	@Output() ClickEvent: EventEmitter<any> = new EventEmitter();
	private isClicked: boolean = false;
	public strProgressVal: string;
	constructor() {}

	ngOnInit() {
		this.setProgress(this.circleEl.nativeElement, this.progressVal);
	}
	ngOnChanges(changes: SimpleChange) {
		this.setProgress(this.circleEl.nativeElement, this.progressVal);
	}

	private setProgress(elem, percent) {
		this.strProgressVal = `${Math.round(percent)}%`;
		let degrees = percent * 3.6;
		let transform = /MSIE 9/.test(navigator.userAgent)
			? "msTransform"
			: "transform";
		//  elem.querySelector('.counter').setAttribute('data-percent', Math.round(percent));
		elem.querySelector(".progressEnd").style[transform] =
			"rotate(" + degrees + "deg)";
		elem.querySelector(".progress").style[transform] =
			"rotate(" + degrees + "deg)";
		if (percent >= 50 && !/(^|\s)fiftyPlus(\s|$)/.test(elem.className))
			elem.className += " fiftyPlus";

		console.log("this.progressVallSpinnerComponene  ", this.progressVal);
	}

	public btnClickHandler(event) {
		//this.isClicked = !this.isClicked;
		this.ClickEvent.emit({ clicked: true });
	}
}
